<template>
  <v-card class="elevation-0 shadow white mt-3 pb-3 flex mt-3">
    <v-card-text>
      <div class="flex-row mb-2 align-center justify-start">
        <div class="py-2 px-3 lable-out">
          <h3>{{ $t("balance_sheet") }}</h3>
        </div>
        <v-spacer />

        <v-autocomplete
          outline
          clearable
          single-line
          hide-details
          return-object
          class="rounded"
          item-value="id"
          item-text="name"
          v-if="showFilter"
          :items="currencies"
          style="max-width: 400px"
          v-model="selected_currencies"
          :label="talab ? 'Payables' : 'Receiveables'"
        >
          <template v-slot:prepend>
            <v-checkbox
              single-line
              hide-details
              color="primary"
              v-model="talab"
              class="pa-0 ma-0"
            />
          </template>
        </v-autocomplete>

        <v-btn
          flat
          icon
          class="ml-0"
          color="grey darken-2"
          @click="printTable(false)"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          class="mx-0"
          color="grey darken-2"
          @click="printTable(true)"
        >
          <v-icon>file_download</v-icon>
        </v-btn>
      </div>
      <v-data-table
        hide-actions
        :headers="headers"
        disable-initial-sort
        :items="computed_accounts"
      >
        <template slot="items" slot-scope="{ item, index }">
          <tr v-if="item.heading">
            <td>{{ index + 1 }}</td>
            <td
              colspan="100%"
              class="py-1 px-3 secondary white--text font-weight-bold"
            >
              {{ item.name }}
            </td>
          </tr>
          <template v-else-if="item.sumup">
            <tr>
              <td>{{ index + 1 }}</td>
              <td class="font-weight-medium body-2">
                {{ $t(item.name) }}
              </td>
              <td
                v-for="currency in computedCurrencies"
                :key="`${index}${currency.id}`"
                class="font-weight-bold"
                :class="{
                  'red--text': item[currency.id] < 0,
                  'activeColor--text': item[currency.id] > 0,
                }"
              >
                <span
                  v-if="
                    item['type'] == 'net_income' &&
                    currency.id != afn_currency_id
                  "
                >
                  {{
                    item[currency.id + "_to_base"]
                      | currency({ symbol: smbl(base_currency_id) })
                  }}
                </span>
                <span v-else>
                  {{
                    item[currency.id] | currency({ symbol: smbl(currency.id) })
                  }}
                </span>
              </td>
              <td class="font-weight-bold">
                {{
                  sumToAfn(item) | currency({ symbol: smbl(afn_currency_id) })
                }}
              </td>
            </tr>
            <tr>
              <!-- <td colspan="100%" /> -->
            </tr>
          </template>
          <tr v-else>
            <td>{{ index + 1 }}</td>
            <!-- <td>{{ $t(item.account_group) }}</td> -->
            <!-- <td>{{ item.code }}</td> -->
            <td>{{ $t(item.name) }}</td>
            <td
              v-for="currency in computedCurrencies"
              :key="`${index}${currency.id}`"
              class="font-weight-bold"
              :class="{
                'red--text': item[currency.id] < 0,
                'activeColor--text': item[currency.id] > 0,
              }"
            >
              <span
                v-if="
                  item['type'] == 'net_income' && currency.id != afn_currency_id
                "
              >
                {{
                  item[currency.id + "_to_base"]
                    | currency({ symbol: smbl(base_currency_id) })
                }}
              </span>
              <span v-else>
                {{
                  item[currency.id] | currency({ symbol: smbl(currency.id) })
                }}
              </span>
            </td>
            <td class="font-weight-bold">
              {{ sumToAfn(item) | currency({ symbol: smbl(afn_currency_id) }) }}
            </td>
          </tr>
        </template>
        <template slot="footer">
          <!--   
          <tr>
            <td colspan="3" class="font-weight-medium body-2">
              {{ $t(balance.total_assets.account_group) }}
            </td>
            <td
              v-for="currency in computedCurrencies"
              class="font-weight-medium body-2"
              :key="`income${currency.id}`"
            >
              {{
                balance.total_assets[currency.id]
                  | currency({ symbol: smbl(currency.id) })
              }}
            </td>
            <td class="font-weight-bold">
              {{
                balanceDiff.total_assets_usd
                  | currency({ symbol: smbl(afn_currency_id) })
              }}
            </td>
          </tr>
          <tr>
            <td colspan="3" class="font-weight-medium body-2">
              {{ $t(balance.total_liabilities.account_group) }}
            </td>
            <td
              v-for="currency in computedCurrencies"
              :key="`expense${currency.id}`"
              class="font-weight-medium body-2"
              :class="{
                'activeColor--text': balance.total_liabilities[currency.id] > 0,
              }"
            >
              {{
                balance.total_liabilities[currency.id]
                  | currency({ symbol: smbl(currency.id) })
              }}
            </td>
            <td class="font-weight-bold">
              {{
                balanceDiff.total_liabilities_usd
                  | currency({ symbol: smbl(afn_currency_id) })
              }}
            </td>
          </tr>
          -->

          <tr>
            <td colspan="3" class="font-weight-medium body-2">
              {{ $t("balance") }}
            </td>
            <td
              class="font-weight-bold"
              :class="{
                'activeColor--text': balanceDiff.diff_usd > 0,
                'red--text': balanceDiff.diff_usd < 0,
              }"
              colspan="100%"
            >
              {{
                balanceDiff.diff_usd
                  | currency({ symbol: smbl(afn_currency_id) })
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import curjs from "currency.js";
import { exchange } from "@/mixins/index.js";

export default {
  mixins: [exchange],
  props: {
    title: "",
    brnch_name: "",
    rates: {
      default: () => {},
    },
    showFilter: false,
    accounts: { default: () => [] },
    currencies: { default: () => [] },
    external: { default: () => false },
  },
  data: () => ({
    talab: false,
    selected_currencies: null,
  }),
  computed: {
    computedCurrencies: (vm) =>
      vm.selected_currencies ? [vm.selected_currencies] : vm.currencies,

    headers() {
      let items = [
        {
          width: "50px",
          sortable: false,
          text: this.$t("number"),
        },
        // {
        //   width: "80px",
        //   value: "account_group",
        //   text: this.$t("account_group"),
        //   computed: (item) => this.$t(item.account_group),
        // },
        {
          value: "name",
          sortable: false,
          text: this.$t("name"),
          computed: (item) => this.$t(item.name),
        },
      ];
      this.computedCurrencies.forEach((item) => {
        let va = item.id;
        items.push({
          width: "200",
          value: va,
          sortable: false,
          text: item.name,
          computed: (ite) => {
            if (ite.heading) return " ";
            return ite.type == "net_income" && va != this.afn_currency_id
              ? `${curjs(ite[va + "_to_base"]).format({
                  symbol: "",
                })} ${this.smbl(this.base_currency_id)}`
              : `${curjs(ite[va]).format({ symbol: "" })} ${this.smbl(va)}`;
          },
        });
      });
      items.push({
        sortable: false,
        text: "AFN Equivalent",
        computed: (item) => {
          if (item.heading) return "";
          return `${curjs(this.sumToAfn(item)).format({
            symbol: "",
          })} ${this.smbl(this.afn_currency_id)}`;
        },
      });
      return items;
    },

    computed_accounts() {
      let assets = this.accounts.filter(
        (x) =>
          x.account_group == "asset" &&
          x.type != "individual" &&
          x.type != "corporate" &&
          x.type != "customer" &&
          x.type != "staff" &&
          x.type != "saraf" &&
          x.type != "branch" &&
          x.type != "commission" &&
          x.type != "bank" &&
          x.type != "system" &&
          !x.is_current_asset
      );

      let cashInHand = this.accounts.filter((x) => x.type == "system");
      let totalCashWithBanks = this.sumUp(
        this.accounts.filter(
          (x) => x.type == "bank" && x.account_group == "asset"
        ),
        "asset",
        "bank",
        "total_cash_with_banks",
        "IND"
      );

      let current_assets = this.accounts.filter(
        (x) => x.is_current_asset && x.account_group == "asset"
      );

      let totalIndividualReceivables = this.sumUp(
        this.accounts.filter(
          (x) =>
            (x.type == "individual" || x.type == "customer") &&
            x.account_group == "asset"
        ),
        "asset",
        "individual",
        "individuals_receivables",
        "IND"
      );

      let totalCorporatesReceivables = this.sumUp(
        this.accounts.filter(
          (x) => x.type == "corporate" && x.account_group == "asset"
        ),
        "asset",
        "corporate",
        "corporates_receivables",
        "COR"
      );

      let totalStaffsReceivables = this.sumUp(
        this.accounts.filter(
          (x) => x.type == "staff" && x.account_group == "asset"
        ),
        "asset",
        "staff",
        "staffs_advance_salary_receivables",
        "SST"
      );

      let totalSarafsReceivables = this.sumUp(
        this.accounts.filter(
          (x) =>
            (x.type == "saraf" || x.type == "commission") &&
            x.account_group == "asset"
        ),
        "asset",
        "saraf",
        "sarafs_receivables",
        "SRT"
      );

      let totalBranchReceivables = this.sumUp(
        this.accounts.filter(
          (x) => x.type == "branch" && x.account_group == "asset"
        ),
        "asset",
        "branch",
        "branch_receivables",
        "BRN"
      );

      let total_current_assets = this.sumUp(
        [
          ...cashInHand,
          totalCashWithBanks,
          ...current_assets,
          totalIndividualReceivables,
          totalCorporatesReceivables,
          totalStaffsReceivables,
          totalSarafsReceivables,
          totalBranchReceivables,
        ],
        "total_current_assets",
        null,
        null,
        null,
        "font-weight-bold"
      );

      let total_fixed_assets = this.sumUp(
        assets,
        "total_fixed_assets",
        null,
        null,
        null,
        "font-weight-bold"
      );

      let total_assets = this.sumUp(
        [total_current_assets, total_fixed_assets],
        "total_assets",
        null,
        null,
        null,
        "font-weight-bold"
      );

      // let totalCustomersReceivables = this.sumUp(
      //   this.accounts.filter(
      //     (x) => x.type == "customer" && x.account_group == "asset"
      //   ),
      //   "asset",
      //   "customer",
      //   "customers_receivables",
      //   "CST"
      // );

      // let totalCustomersPayables = this.sumUp(
      //   this.accounts.filter(
      //     (x) => x.type == "customer" && x.account_group != "asset"
      //   ),
      //   "liability",
      //   "customer",
      //   "customers_payable",
      //   "CST"
      // );

      // let totalCommissionReceivables = this.sumUp(
      //   this.accounts.filter(
      //     (x) => x.type == "commission" && x.account_group == "asset"
      //   ),
      //   "asset",
      //   "commission",
      //   "sarafs_com_receivables",
      //   "SRCOM"
      // );

      // let totalCommissionsPayables = this.sumUp(
      //   this.accounts.filter(
      //     (x) => x.type == "commission" && x.account_group != "asset"
      //   ),
      //   "liability",
      //   "commission",
      //   "sarafs_com_payable",
      //   "SRCOM"
      // );

      let liabilities = this.accounts.filter(
        (x) =>
          x.account_group == "liability" &&
          x.type != "individual" &&
          x.type != "corporate" &&
          x.type != "customer" &&
          x.type != "staff" &&
          x.type != "saraf" &&
          x.type != "branch" &&
          x.type != "commission"
      );

      let totalIndividualPayables = this.sumUp(
        this.accounts.filter(
          (x) =>
            (x.type == "individual" || x.type == "customer") &&
            x.account_group != "asset"
        ),
        "liability",
        "individual",
        "individuals_payable",
        "IND"
      );

      let totalStaffsPayables = this.sumUp(
        this.accounts.filter(
          (x) => x.type == "staff" && x.account_group != "asset"
        ),
        "liability",
        "staff",
        "staffs_salary_payable",
        "SST"
      );

      let totalSarafsPayables = this.sumUp(
        this.accounts.filter(
          (x) =>
            (x.type == "saraf" || x.type == "commission") &&
            x.account_group != "asset"
        ),
        "liability",
        "saraf",
        "sarafs_payable",
        "SRT"
      );

      let totalCorporatesPayables = this.sumUp(
        this.accounts.filter(
          (x) => x.type == "corporate" && x.account_group != "asset"
        ),
        "liability",
        "corporate",
        "corporates_payable",
        "COR"
      );

      let totalBranchPayables = this.sumUp(
        this.accounts.filter(
          (x) => x.type == "branch" && x.account_group != "asset"
        ),
        "liability",
        "branch",
        "branch_payable",
        "BRN"
      );

      let total_liabilities = this.sumUp(
        [
          totalIndividualPayables,
          totalCorporatesPayables,
          totalStaffsPayables,
          totalSarafsPayables,
          totalBranchPayables,
          ...liabilities,
        ],
        "total_liabilities",
        null,
        null,
        null,
        "font-weight-bold"
      );

      let totalEquity = this.sumUp(
        this.accounts.filter(
          (x) => x.account_group == "equity" && x.type == "shareholder"
        ),
        "capital",
        "shareholder",
        "shareholders_payable",
        "SHA"
      );

      let netIncome = this.sumUp(
        this.accounts.filter(
          (x) =>
            (x.type == "expense" || x.type == "income") &&
            x.account_group != "asset"
        ),
        "net_income",
        "net_income",
        "net_income",
        "NI"
      );

      let total_capital = this.sumUp(
        [totalEquity, netIncome],
        "total_capital",
        null,
        null,
        null,
        "font-weight-bold"
      );

      let capital_and_liabilities = this.sumUp(
        [total_capital, total_liabilities],
        "capital_and_liabilities",
        null,
        null,
        null,
        "font-weight-bold"
      );

      let data = [];
      data.push(
        {
          heading: true,
          class: "body-1 font-weight-bold",
          name: this.$t("current_assets"),
        },
        ...cashInHand,
        totalCashWithBanks,
        ...current_assets,
        totalIndividualReceivables,
        totalCorporatesReceivables,
        // totalCustomersReceivables,
        totalStaffsReceivables,
        totalSarafsReceivables,
        totalBranchReceivables,
        // totalCommissionReceivables,
        {
          sumup: true,
          ...total_current_assets,
        },
        {
          heading: true,
          class: "body-1 font-weight-bold",
          name: this.$t("fixed_assets"),
        },
        ...assets,
        {
          sumup: true,
          ...total_fixed_assets,
        },
        {
          heading: true,
          class: "body-1 font-weight-bold",
          name: this.$t("current_liabilities"),
        },
        totalIndividualPayables,
        totalCorporatesPayables,
        // totalCustomersPayables,
        totalStaffsPayables,
        totalSarafsPayables,
        totalBranchPayables,
        // totalCommissionsPayables,
        ...liabilities,
        {
          sumup: true,
          ...total_liabilities,
        },
        {
          heading: true,
          class: "body-1 font-weight-bold",
          name: this.$t("capital"),
        },
        totalEquity,
        netIncome,
        {
          sumup: true,
          ...total_capital,
        },
        {
          sumup: true,
          total_asset: true,
          ...total_assets,
        },
        {
          sumup: true,
          capital_and_liabilities: true,
          ...capital_and_liabilities,
        }
      );
      return data;
    },

    balance() {
      let total_assets = this.sumUp(
        this.computed_accounts.filter((x) => x.total_asset),
        "total_assets",
        null,
        null,
        null,
        "font-weight-bold"
      );
      let total_liabilities = this.sumUp(
        this.computed_accounts.filter((x) => x.capital_and_liabilities),
        "total_liabilities",
        null,
        null,
        null,
        "font-weight-bold"
      );
      return { total_assets, total_liabilities };
    },

    balanceDiff() {
      let total_assets_usd = curjs(
        this.sumToAfn(this.balance.total_assets)
      ).value;
      let total_liabilities_usd = curjs(
        this.sumToAfn(this.balance.total_liabilities)
      ).value;
      let diff_usd = curjs(total_assets_usd).subtract(
        total_liabilities_usd
      ).value;
      if (diff_usd < 3 && diff_usd > -3) diff_usd = 0;
      return { total_assets_usd, total_liabilities_usd, diff_usd };
    },
  },

  methods: {
    sumToAfn(item) {
      let total = 0;
      let rates = this.rates;
      // defiend in bootstrapjs
      let base_currency = rates[this.base_currency_id] || {
        rank: 2,
        name: "",
        rate: 1,
      };
      let afnCurrency = rates[this.afn_currency_id] || {
        rank: 3,
        name: "",
        rate: 1,
      };

      this.currencies.forEach((currency) => {
        let cr = rates[currency.id] ? rates[currency.id].rate : 1;
        let rate = this.getRate(
          currency.rank,
          afnCurrency.rank,
          base_currency.rank,
          cr,
          afnCurrency.rate
        );
        total = curjs(total).add(
          this.exchange(currency, afnCurrency, item[currency.id], rate)
        );
      });
      return total;
    },
    sumToUSD(item) {
      // total_in_usd
      let total = 0;
      let rates = this.rates;
      // defiend in bootstrapjs
      let base_currency = rates[this.base_currency_id] || {
        rank: 2,
        name: "",
        rate: 1,
      };
      // let afnCurrency = rates[this.afn_currency_id] || {
      //   rank: 3,
      //   name: "",
      //   rate: 1,
      // };

      this.currencies.forEach((currency) => {
        // comes from mixin
        let cr = rates[currency.id] ? rates[currency.id].rate : 1;
        // let rate = this.getRate(
        //   currency.rank,
        //   afnCurrency.rank,
        //   base_currency.rank,
        //   cr,
        //   afnCurrency.rate
        // );
        total = curjs(total).add(
          this.exchange(currency, base_currency, item[currency.id], cr)
        ).value;
      });
      return total;
    },

    sumUp(items, account_group, type, name, code, class_name) {
      let total = {
        name: name || account_group,
        type,
        code,
        class: class_name,
      };
      items.forEach((item) => {
        this.currencies.forEach((currency) => {
          if (item.type == "expense") {
            total[currency.id] = curjs(total[currency.id] || 0).subtract(
              item[currency.id]
            ).value;
            total[currency.id + "_to_base"] = curjs(
              total[currency.id + "_to_base"] || 0
            ).subtract(item[currency.id + "_to_base"]).value;
          } else {
            total[currency.id] = curjs(total[currency.id] || 0).add(
              item[currency.id]
            ).value;

            total[currency.id + "_to_base"] = curjs(
              total[currency.id + "_to_base"] || 0
            ).add(item[currency.id + "_to_base"]).value;
          }
        });
      });
      return total;
    },

    printTable(excel) {
      let items = this.computed_accounts;
      // items.push(this.balance.total_assets, this.balance.total_liabilities);
      // let footers = [
      //   `<td colspan="3" class="font-weight-medium body-2">
      //       ${this.$t("balance")}
      //     </td><td colspan="100%" class="font-weight-bold red--text">
      //       ${curjs(this.balanceDiff.diff_usd).format({
      //         symbol: "",
      //       })} ${this.smbl(this.afn_currency_id)}
      //     </td>`,
      // ];
      let data = {
        items,
        // footers,
        landscape: true,
        title: this.title,
        brnch_name: this.brnch_name,
        headers: this.headers.slice(1),
      };

      if (excel)
        return this.xl_tables(data, "balance sheet", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
};
</script>
 